
export class CalendarWeek {
    /** @type {string} */
    key: string = "";

    /** @type {number} */
    cw: number;

    /** @type {number} */
    year: number;

    /** @type {Date} */
    cw_start: Date; // Monday of the week

    /** @type {Date} */
    cw_end: Date; // Friday of the week

    /**
     * Create new calendar week
     * @param {Object} param0 The calendar week parameters
     * @param {string} param0.key The calendar week ID. Example: cw_40_2023
     * @param {number} param0.cw The week number in a year
     * @param {number} param0.year The year of calendar week
     * @param {Date} param0.cw_start The start date of the calendar week, consider to be Monday
     * @param {Date} param0.cw_end The end date of the calendar week, consider to be Friday
     */
    constructor({ key, cw, year, cw_start, cw_end }: { key: string; cw: number; year: number; cw_start: Date; cw_end: Date }) {
        this.key = key;
        this.cw = cw;
        this.year = year;
        this.cw_start = cw_start;
        this.cw_end = cw_end;
    }

    /**
     * @returns {Date[]}
     */
    getDaysOfWeek() {
        const daysOfWeek = new Array();
        const current = new Date(this.cw_start);

        for (var i = 0; i < 5; i++) {
            daysOfWeek.push(
                new Date(current)
            );
            current.setDate(current.getDate() + 1);
        }

        return daysOfWeek;
    }
}
